import { useProjectId } from '@consigli/hooks';
import { FC, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { DownloadMenu } from './download-menu';
import { EmailSummaryButton } from './email-summary-button';
import { JoinMeetingButton } from './join-meeting-button';
import { MeetingDescriptionCard } from './meeting-description-card';
import { MeetingDetails, MeetingSummary } from '../meeting-secretary-detail';

import type { Meeting } from '../meeting-secretary-detail';
import type { MeetingSummaryData } from '../types';

export const MeetingDetail: FC<{ meeting: Meeting }> = ({ meeting }) => {
  const projectId = useProjectId();
  const { t } = useTranslation();
  const [meetingSummaryData, setMeetingSummaryData] = useState<MeetingSummaryData | null>(null);

  const handleDataUpdate = useCallback((data: MeetingSummaryData) => {
    setMeetingSummaryData(data);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="border-gray-200 px-6 py-4">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900 capitalize">{meeting.title}</h1>
            <p className="text-gray-600 mt-1">{t('meeting-secretary.meetings.meeting-detail')}</p>
          </div>
          <div className="flex items-center space-x-3">
            <JoinMeetingButton joinUrl={meeting.joinUrl} description={meeting.description} />
            <EmailSummaryButton
              meeting={meeting}
              meetingData={meetingSummaryData}
              projectId={projectId}
            />
            <DownloadMenu meetingData={meetingSummaryData} />
          </div>
        </div>
      </div>

      <div className="w-full mx-auto px-6 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-6 gap-8">
          <div className="lg:col-span-2 space-y-6">
            <MeetingDetails meeting={meeting} />
            <MeetingDescriptionCard description={meeting.description} />
          </div>
          <div className="lg:col-span-4">
            <MeetingSummary meeting={meeting} onDataUpdate={handleDataUpdate} />
          </div>
        </div>
      </div>
    </div>
  );
};
